export interface BillingCountryOption {
  code: string;
  label: string;
}

const POPULAR_BILLING_COUNTRY_CODES = [
  'US', 'GB', 'CA', 'AU', 'DE', 'FR', 'ES', 'IT', 'NL', 'CZ', 'SK', 'PL', 'AT', 'CH', 'IE', 'BE', 'SE', 'DK', 'NO', 'FI',
] as const;

const OTHER_BILLING_COUNTRY_CODES = [
  'AE', 'AF', 'AL', 'AM', 'AO', 'AR', 'AZ', 'BA', 'BD', 'BG', 'BH', 'BO', 'BR', 'BY', 'CL', 'CM', 'CN', 'CO', 'CR', 'CY',
  'DO', 'EC', 'EE', 'EG', 'GE', 'GR', 'HK', 'HR', 'HU', 'ID', 'IL', 'IN', 'IS', 'JP', 'KE', 'KR', 'KZ', 'LI', 'LT', 'LU',
  'LV', 'MA', 'MD', 'ME', 'MK', 'MR', 'MT', 'MX', 'MY', 'NG', 'NZ', 'OM', 'PE', 'PH', 'PT', 'RO', 'RS', 'RU', 'SA', 'SG',
  'SI', 'SV', 'TH', 'TR', 'TW', 'TZ', 'UA', 'UY', 'UZ', 'VE', 'VN', 'ZA',
] as const;

type DisplayNamesConstructor = new (locales: string[], options: { type: 'region' }) => {
  of(code: string): string | undefined;
};

const intlWithDisplayNames = Intl as typeof Intl & { DisplayNames?: DisplayNamesConstructor };
const regionNames = intlWithDisplayNames.DisplayNames
  ? new intlWithDisplayNames.DisplayNames(['en'], { type: 'region' })
  : null;

function makeOption(code: string): BillingCountryOption {
  return {
    code,
    label: regionNames?.of(code) || code,
  };
}

const popularCodeSet = new Set<string>(POPULAR_BILLING_COUNTRY_CODES);

export const BILLING_COUNTRY_OPTIONS: BillingCountryOption[] = [
  ...POPULAR_BILLING_COUNTRY_CODES.map(makeOption),
  ...OTHER_BILLING_COUNTRY_CODES
    .filter((code) => !popularCodeSet.has(code))
    .map(makeOption)
    .sort((left, right) => left.label.localeCompare(right.label)),
];
